import { spokeNameProblem } from '@internal/azure-regions';
import {
  findSpokeNameConflict,
  getKnownSpokeNames,
  spokeNameConflictMessage,
} from './spokeNameConflict';

interface ErrorSink {
  addError: (message: string) => void;
}

// The region is chosen on the same page; until it is, check the rules that
// hold everywhere (West Europe's limit is the loosest the estate allows).
const DEFAULT_REGION = 'WE';

export const validateSpokeName = (
  value: string | undefined,
  validation: ErrorSink,
  formData?: { region?: string },
): void => {
  if (!value) return;

  const problem = spokeNameProblem(value, formData?.region || DEFAULT_REGION);
  if (problem) {
    validation.addError(problem);
    return;
  }

  const conflict = findSpokeNameConflict(value, getKnownSpokeNames());
  if (conflict) {
    validation.addError(spokeNameConflictMessage(conflict));
  }
};
